export const booleanField = {
  control: 'checkbox',
  values: [true, false],
};
